module.exports = __webpack_public_path__ + "media/images/badge/nerd_secondary-91fe6a4cf9d673a5ea3e46491fb0c74e.png";